/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./_build/scripts/components/gated-content.js":
/*!****************************************************!*\
  !*** ./_build/scripts/components/gated-content.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ GatedContent)
/* harmony export */ });
class GatedContent {
  constructor (options = {}) {
    this.options = {...this.getDefaultOptions(), ...options};

    this.initGatedContent();
  }

  getDefaultOptions() {
    return {
      lockContentOnScroll: true,
      onAllowContent: () => {},
      formSelector: '[data-gated-content-form-selector]',
      form: '[data-form]',
      button: '[data-download-button]',
      closeButton: '[data-close-button]'
    }
  }

  initGatedContent() {
    if (this.ifFormSuccess()) {
      this.createLocalStorageCache();
      this.clearParamsHistory();
      this.options.onAllowContent();
      this.showButtonOnScroll();
    } else if (this.ifValidSession()) {
      this.options.onAllowContent();
      this.showButtonOnScroll();
    } else {
      this.lockContentOnScroll();
    }
  }

  ifFormSuccess() {
    const urlParams = new URLSearchParams(window.location.search);
    const formFilled = urlParams.get('form_filled');

    return formFilled == 'true' ? true : false;
  }

  ifValidSession() {
    const existingItem = localStorage.getItem(this.getUniqueIdentifierKey());

    if (!existingItem) return false;

    if (existingItem != 'true') return false;

    return true;
    
  }

  lockContentOnScroll() {
    if (this.options.lockContentOnScroll) {
      window.addEventListener('scroll', (e) => {
        if (window.scrollY >= 600) {
          this.showAccessForm();
        }
      });
    }
  }

  showButtonOnScroll() {
    window.addEventListener('scroll', (e) => {
      if (window.scrollY >= 600) {
        this.showButton();
      }
    });
  }

  showAccessForm() {
    document.body.style.overflow = 'hidden';
    document.querySelector(this.options.formSelector).classList.add('is-visible'),
    document.querySelector(this.options.closeButton).tabIndex = 1;
    document.querySelector(this.options.form).tabIndex = 2;
  }

  showButton() {
    document.querySelector(this.options.button).classList.add('is-visible')
  }

  createLocalStorageCache() {
    localStorage.setItem(this.getUniqueIdentifierKey(), true);
  }

  clearParamsHistory() {
    history.pushState(null, "", location.href.split("?")[0]);
  }

  getUniqueIdentifierKey() {
    const wrapper = document.querySelector(this.options.formSelector);
    return `accepted-${wrapper.dataset.uniqueIdentifier}`;
  }
}

/***/ }),

/***/ "./_build/scripts/components/theme-section-loader.js":
/*!***********************************************************!*\
  !*** ./_build/scripts/components/theme-section-loader.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addThemeLoadEvent: () => (/* binding */ addThemeLoadEvent),
/* harmony export */   delayedLoadSection: () => (/* binding */ delayedLoadSection),
/* harmony export */   loadSection: () => (/* binding */ loadSection)
/* harmony export */ });
//
// Theme Section Loader for Herd themes
//
function loadSection(name, events) {
  console.log('loadsection function for ', name);
  if (!Shopify.theme.sections || !Shopify.theme.sections.register) {
    delayedLoadSection(name, events);
    return;
  }
  const sectionInstances = Shopify.theme.sections.getInstances(name);
  if (sectionInstances.length === 0) {
    Shopify.theme.sections.register(name, events);
  }
  Shopify.theme.sections.load(name);
}

function delayedLoadSection(name, events) {
  var sectionTemplate = { name, events };
  console.log('push section template to theme.liquid var for later loading: ', sectionTemplate);
  theme.sections.push(sectionTemplate);
}

function addThemeLoadEvent() {
  window.addEventListener('load', () => {
    console.log('Theme: Load event fired with sections: ', theme.sections);

    theme.sections.forEach((sectionTemplate) => {
      const sectionInstances = Shopify.theme.sections.getInstances(sectionTemplate.name);
      if (Shopify.theme.sections && sectionInstances.length === 0) {
        Shopify.theme.sections.register(sectionTemplate.name, sectionTemplate.events);
      }
      Shopify.theme.sections.load(sectionTemplate.name);
    });
  });
}




/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!********************************************!*\
  !*** ./_build/scripts/sections/article.js ***!
  \********************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_theme_section_loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/theme-section-loader */ "./_build/scripts/components/theme-section-loader.js");
/* harmony import */ var _components_gated_content__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../components/gated-content */ "./_build/scripts/components/gated-content.js");



selectors = {
  gatedContentFormWrapper: '[data-gated-content-form-selector]',
  gatedContentForm: '[data-gated-content-form]',
  articleContent: '[data-article-wrapper]',
};

const sectionEvents = {
  onLoad() {
    this.initGatedContent();
  },

  initGatedContent() {
    const gatedContentFormWrapper = this.container.querySelector(selectors.gatedContentFormWrapper);
    if (!gatedContentFormWrapper) return;

    new _components_gated_content__WEBPACK_IMPORTED_MODULE_1__["default"]({
      onAllowContent: () => {console.log('Allowing Content')}
    });
  }
};

(0,_components_theme_section_loader__WEBPACK_IMPORTED_MODULE_0__.loadSection)('section-article', sectionEvents);

})();

/******/ })()
;